import IWall from 'components/interfaces/IWall';
import { isWoodyTypeWallByType } from 'components/configurator/types/glazingWallTypesCheck';
import IValidationError from './IValidationError';

const validateWoodyWall = (wall: IWall): IValidationError[] => {
  const validationErrors: IValidationError[] = [];

  if (!isWoodyTypeWallByType(wall.glazingWallType)) {
    return validationErrors;
  }

  if (wall.woodyProfileWidth < 75 || wall.woodyProfileWidth > 215) {
    validationErrors.push({
      message: 'Woody profile width should be in between 75 mm and 215 mm',
      property: 'woodyProfileWidth',
    });
  }

  const minimumGlassThickness = Math.ceil(
    window.CommonFunctions.GetGlassThickness(wall.glassType)
  );

  const getMinimumGlassThicknessMessage = (side: string) =>
    `Woody ${side} groove width should be more than ${minimumGlassThickness}`;
  if (wall.woodyLeftGrooveWidth < minimumGlassThickness) {
    validationErrors.push({
      message: getMinimumGlassThicknessMessage('left'),
      property: 'woodyLeftGrooveWidth',
    });
  }

  if (wall.woodyRightGrooveWidth < minimumGlassThickness) {
    validationErrors.push({
      message: getMinimumGlassThicknessMessage('right'),
      property: 'woodyRightGrooveWidth',
    });
  }

  if (wall.woodyFloorGrooveWidth < minimumGlassThickness) {
    validationErrors.push({
      message: getMinimumGlassThicknessMessage('floor'),
      property: 'woodyFloorGrooveWidth',
    });
  }

  if (wall.woodyRoofGrooveWidth < minimumGlassThickness) {
    validationErrors.push({
      message: getMinimumGlassThicknessMessage('roof'),
      property: 'woodyRoofGrooveWidth',
    });
  }

  return validationErrors;
};

export default validateWoodyWall;
